import { render } from "./MainTitle.vue?vue&type=template&id=79e5889f&scoped=true"
const script = {}

import "./MainTitle.vue?vue&type=style&index=0&id=79e5889f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e5889f"]])

export default __exports__